// extracted by mini-css-extract-plugin
export default {"wrapper":"LayoutWrapper_wrapper__0gBD3","resizer":"LayoutWrapper_resizer__ERG+D"};